import { Link } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import "./AdminHome.css";

const LINKS = [
  { to: "/admin/approvals/creators", label: "Creator Approvals", hint: "Review pending applications" },
  { to: "/admin/approvals/fans", label: "Fan Waitlist", hint: "Batch-approve waitlisted fans" },
  { to: "/admin/support", label: "Support Inbox", hint: "Triage and reply to tickets" },
  { to: "/admin/comment-reports", label: "Comment Reports", hint: "Review flagged drop comments" },
  { to: "/admin/suggestions", label: "Suggestions", hint: "See what creators and fans are asking for" },
  { to: "/admin-reports", label: "Content Reports", hint: "Review flagged drops and content" },
  { to: "/admin/email-templates", label: "Email Templates", hint: "Preview golden-ticket emails" },
  { to: "/admin/outreach", label: "Outreach Drafts", hint: "Generate creator outreach" },
  { to: "/admin/users", label: "Users", hint: "Look up platform accounts" },
  { to: "/admin/settings", label: "Settings", hint: "Waitlist and platform flags" },
];

export default function AdminHome() {
  return (
    <AdminLayout>
      <div className="admin-home">
        <div className="admin-page-header">
          <div className="admin-eyebrow">Admin</div>
          <div className="admin-page-title">Dashboard</div>
          <span className="admin-page-hand">— pick a tool from the sidebar or below</span>
        </div>

        <div className="admin-home-grid">
          {LINKS.map((link) => (
            <Link key={link.to} to={link.to} className="admin-home-card">
              <div className="admin-home-card-title">{link.label}</div>
              <div className="admin-home-card-hint">{link.hint}</div>
            </Link>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
